<template>
  <v-container
    fluid
    cols="12"
    class="d-flex"
  >
    <v-layout
      row
      wrap
    >
      <template>
        <v-flex xs12>
          <v-card
            class="ma-2"
          >
            <v-card-title class="toolbar success white--text subheading">
              <span>Account Settings</span>
            </v-card-title>

            <v-card-text>
              <v-layout
                wrap
                class="pa-0"
              >
                <v-flex
                  class="pa-2"
                  xs12
                >
                  <div>
                    <h1>{{ strategy.strategyName }} ({{ strategy.active ? 'active' : 'paused' }})</h1>
                    <h3>E-MONEY BALANCE: <i>{{ balance }}</i></h3>
                  </div>
                </v-flex>
                <v-flex
                  class="pa-2"
                  xs12
                >
                  <div>
                    User:
                  </div>
                  <UserChip
                    :id="strategy.userId"
                  />
                </v-flex>
                <v-flex
                  class="pa-2"
                  xs12
                >
                  <div>
                    Mangopay:
                  </div>
                  <MangopayChip
                    :id="strategy.mangoPay.id"
                    :wallet-id="strategy.mangoPay.walletId"
                    :mandate-id="strategy.mangoPay.mandateId"
                  />
                </v-flex>
                <v-flex>
                  <h3>
                    Withdrawal Info
                  </h3>
                  <div>
                    <b>Allowed withdrawal amount:</b>
                    {{ allowedWithdrawalInfo ? allowedWithdrawalInfo.allowedWithdrawalAmount/100 : 'no data' }}€
                  </div>
                  <div>
                    <b>Maximum allowed amount per period:</b>
                    {{ allowedWithdrawalInfo ? allowedWithdrawalInfo.maximumAllowedAmountPerPeriod/100 : 'no data' }}€
                  </div>
                  <div>
                    <b>Period in days:</b> {{ allowedWithdrawalInfo ? allowedWithdrawalInfo.periodDays : 'no data' }}
                  </div>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </template>
    </v-layout>
  </v-container>
</template>
<script>

import axios from 'axios';
import MangopayChip from '@/components/shared/mangopay/MangopayChip';
import UserChip from '@/components/shared/user/UserChip';

export default {
  name: 'ShowAccountSettings',
  components: {
    UserChip,
    MangopayChip,
  },
  props: {
    strategy: {
      type: Object,
      required: true,
    },
    refresh: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    balance: 0,
    allowedWithdrawalInfo: null,
    selectedUser: null,
    isLoading: false,
  }),
  watch: {
    strategy() {
      this.getEMoneyBalance();
    },
  },
  mounted() {
    this.getEMoneyBalance();
    this.getAllowedWithdrawalInfo();
  },
  methods: {
    getEMoneyBalance() {
      axios.get(
        `${window.BASE_API.STRATEGIES}/strategy-admin/${this.strategy.id}/ewallet-balance`,
      ).then((data) => {
        this.balance = `${data.data.balance.amount / 100} ${data.data.balance.currency}`;
      });
    },
    getAllowedWithdrawalInfo() {
      axios.get(
        `${window.BASE_API.STRATEGIES}/bankAccount-admin/allowed-withdrawal-amount/${this.strategy.userId}`,
      ).then((response) => {
        this.allowedWithdrawalInfo = response.data;
      });
    },
  },
};
</script>
<style lang="scss" >
.v-data-iterator .v-list__tile{
  height: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/digitalDepots/dialog/account/ShowAccountSettings.vue